import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { HeaderSub2 } from '../../Common/HeaderSub2'
import { ComPhoto } from "../../../js/ComponentManager";
import { Footer } from '../../Common/Footer'
import { Big3Common } from '../../../js/IncludeManager'


/* 개발담당:양유빈
 * 화면기능:라이브 챗 리스트
 * 세부설명:
*/

export class LiveChatList extends Component {
    static displayName = LiveChatList.name;

    constructor(props) {
        super(props);
        this.state = {
            ChatList: []
        };
       
    }
    //초기화
    componentDidMount() {
        this.CallLiveChatListData();
    }
    //채팅방 리스트
    async CallLiveChatListData() {
        try {

            Big3Common.Util.LoadingOn();

            let Data = await Big3Common.Post('api/Order/LiveChat/GetChatmgtList', {});
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const CallList = JSON.parse(Data.dataTable);
                this.setState({ ChatList: CallList });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallLiveChatListData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }

    ChatListrender() {
        const ChatList = this.state.ChatList;
        return (
            <div>
                {
                    ChatList.map((list, idx) =>
                        <Link to={`/Order/LiveChat/Index?union_uid=${list.union_uid}`} key={idx}>
                            <div className="alert_content">
                                <div className="alert_img">
                                    <ComPhoto className="alert_img_in" Photo={list.retail_photo} />
                                </div>
                                <div className="alert_txt">
                                    <div className="alert_title">{list.retail_org_name}</div>
                                    <div className="alert_detail">{list.contt}</div>
                                    <div className="alert_time">{list.reg_dt}{list.conf_count > 0 ? <div className="alert_new"></div> : ""}</div>
                                </div>
                            </div>
                        </Link>
                        
                    )
                }
            </div>
        )
    }
    render() {
        const ChatListrender = this.ChatListrender();
        return (
            <>
                <HeaderSub2
                    HeaderTitle="채팅문의"
                    HistoryBack={true}
                    RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                    ComponentName="LiveChatList"
                />
                <div className="tap_box tap_box_v2">
                    <Link to="/Order/QuestionMgr/Index">
                        <div className="n_tap"><div className="alert_tap">주문문의</div></div>
                    </Link>
                    <div className="n_tap">
                        <div className="alert_tap tap_on">
                            채팅문의
                            <sup>βeta</sup>
                        </div>
                    </div>
                </div>
                <div className="container_box m_f_margin d_padding">
                    {ChatListrender}
                </div>
                <Footer
                    fillName="icon4"
                    ComponentName="LiveChatList"
                />
            </>
        );
    }
}
